import React, { useState } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { v4 } from 'uuid';
import {
  Answer,
  Container,
  Search,
  ContainerHeader,
  ContainerTaskLabel,
  ContainerAnswers,
  Tester,
  Title,
  Text,
  WrittenResponse,
  NoResults,
} from './styles';

const renderAnswers = (answer) => (
  <Answer key={v4()}>
    <Tester>{answer.firstName}</Tester>
    <WrittenResponse>{answer.valueText}</WrittenResponse>
  </Answer>
);

const QuestionsWritten = (props) => {
  const {
    data,
  } = props;

  const [search, setSearch] = useState('');

  const handleSearchChange = (evt) => {
    setSearch(evt.target.value === ' ' ? _.trim(evt.target.value) : evt.target.value);
  };

  const getAnswers = () => {
    const searchFormated = _.toLower(search);

    const responses = searchFormated && _.filter(data.writtenAnswers, (answer) => (
      _.includes(_.toLower(answer.firstName), searchFormated)
      || _.includes(_.toLower(answer.valueText), searchFormated)
    ));

    if (search) {
      return !_.isEmpty(responses)
        ? responses.map((response) => renderAnswers(response))
        : <NoResults>No results found.</NoResults>;
    }

    return data.writtenAnswers.map((answer) => renderAnswers(answer));
  };

  return (
    <Container>
      <ContainerHeader>
        <ContainerTaskLabel>
          <Title>Written Response:</Title>
          <Text>{data.label}</Text>

        </ContainerTaskLabel>
        <Search
          placeholder="Search written responses"
          input={{
            icon: 'search',
            iconPosition: 'left',
          }}
          loading={false}
          onSearchChange={handleSearchChange}
          open={false}
          value={search}
          width="390px"
        />
      </ContainerHeader>

      <ContainerAnswers>
        {getAnswers()}
      </ContainerAnswers>

    </Container>
  );
};

QuestionsWritten.propTypes = {
  data: PropTypes.shape({
    label: PropTypes.string.isRequired,
    writtenAnswers: PropTypes.arrayOf(PropTypes.shape({
      valueText: PropTypes.string,
      firstName: PropTypes.string,
      testerId: PropTypes.string,
    })),
  }).isRequired,
};

export default QuestionsWritten;
